import React from 'react'

import Variant, { variants } from './Variant'

const Component = ({
  resource,
  selectedVariant,
  onChange
}) => (
  <>
    { variants.map(variant => (
      <Variant
        key={variant}
        resource={resource}
        variant={variant}
        onChange={onChange}
        selected={selectedVariant === variant} />
    ))}
  </>
)

export default Component